export const defaultContentInstructions = `Generate engaging social media content for the following dates. Each date should have unique, varied content while maintaining consistency with the overall theme.

1. **Day-Specific Appropriateness**: Tailor tone and messaging to the day of the week
  - Mondays: Motivational, fresh starts, goal-setting
  - Mid-week: Productivity tips, encouragement
  - Fridays: Celebration, weekend preparation
  - Weekends: Relaxation, leisure, reflection

2. **Variation**: Vary formats (questions, tips, stories), tones, and hooks across dates. Never reuse the same opening or structure.

3. **Quality**: Error-free, engaging, valuable copy. Culturally appropriate for the audience.

**Summary** (caption / short post):
- 1–2 sentences with a strong hook; about 250 characters unless the channel needs shorter
- Hashtags and emojis only when they fit the brand

**Description** (longer post body):
- Several sentences expanding the summary; line breaks for readability
- Close with a call-to-action or question when it helps engagement`;

export type ContentInstructionSettings = {
  contentInstructions?: string | null;
};

export function resolveContentInstructions(
  settings: ContentInstructionSettings | null | undefined
): string {
  const unified = settings?.contentInstructions?.trim();
  if (unified) {
    return unified;
  }
  return defaultContentInstructions;
}
